import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../../utils/helpers";

const Stepper = ({ step }) => {
  const ARRAY_STEP = [
    {
      name: "Configuración y Archivo",
      number: 1,
      description: "Configura la base de datos y selecciona el CSV",
    },
    {
      name: "Mapear Campos",
      number: 2,
      description: "Configura las columnas del CSV",
    },
    {
      name: "Confirmar y subir archivo",
      number: 3,
      description: "Revisa la información y sube el archivo",
    },
    {
      name: "Guardar datos",
      number: 4,
      description: "Envía el nuevo archivo generado",
    },
  ];

  return (
    <div className="w-full my-2">
      <div className="relative">
        <div className="absolute left-0 right-0 top-5 h-0.5 bg-gray-300 -translate-y-1/2 transition-all duration-300 ease-in-out"></div>
        <div
          className="absolute left-0 top-5 h-0.5 bg-blue-600 -translate-y-1/2 transition-all duration-300 ease-in-out"
          style={{
            width: `${
              ((step - 1) / (ARRAY_STEP.length - 1)) * 100 +
              (step === 2 ? 5 : 0 )
            }%`,
          }}
        ></div>

        <div className="relative flex justify-between">
          {ARRAY_STEP.map((item, index) => (
            <div className="flex flex-col items-center" key={index}>
              <div className="relative z-10">
                <div
                  className={classNames(
                    "w-10 h-10 rounded-full border-2 flex items-center justify-center transition-all duration-300",
                    {
                      "border-blue-600 bg-blue-600": item.number <= step,
                      "border-gray-300 bg-white": item.number > step,
                      "border-blue-600 bg-white": item.number > step,
                    }
                  )}
                >
                  <span
                    className={classNames(
                      "font-bold transition-all duration-300",
                      {
                        "text-white": item.number <= step,
                        "text-gray-400": item.number > step,
                      }
                    )}
                  >
                    {item.number}
                  </span>
                </div>
              </div>

              <div className="mt-4 text-center max-w-[180px]">
                <div
                  className={classNames(
                    "font-semibold text-[14px] transition-all duration-300",
                    {
                      "text-blue-600": item.number <= step,
                      "text-gray-400": item.number > step,
                    }
                  )}
                >
                  {item.name}
                </div>
                <div
                  className={classNames(
                    "text-[12px] mt-1 transition-all duration-300",
                    {
                      "text-gray-600": item.number <= step,
                      "text-gray-400": item.number > step,
                    }
                  )}
                >
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Stepper.propTypes = {
  step: PropTypes.number,
};

export default Stepper;
